<script lang="ts">
  // Shards readout for the box shop: your Shards balance + which pick tiers it can already afford.
  // Shards are the SAME crafting currency as cards (no separate "dust"), a box duplicate dismantles
  // into Shards, and you spend Shards to pick any unowned item, so progress is always concrete.
  import { PICK_COST, GACHA_RARITIES } from "@ygoevo/world-protocol";
  import { GACHA_TEXT, GACHA_LABEL } from "../cosmetic-rarity.ts";

  let { shards, compact = false }: { shards: number; compact?: boolean } = $props();
</script>

<div class="flex flex-col gap-1.5">
  <div class="flex items-center justify-between">
    <span class="font-display text-[0.58rem] uppercase tracking-widest text-ink-dim">◆ Shards</span>
    <span class="font-display text-xs font-bold tabular-nums text-cyan">{shards.toLocaleString()}</span>
  </div>
  {#if !compact}
    <div class="flex flex-wrap gap-x-2 gap-y-0.5">
      {#each GACHA_RARITIES as r (r)}
        <span class="font-display text-[0.55rem] uppercase tracking-wide {shards >= PICK_COST[r] ? GACHA_TEXT[r] : 'text-ink-dim/40'}" title={shards >= PICK_COST[r] ? `Can craft a ${GACHA_LABEL[r]}` : `${(PICK_COST[r] - shards).toLocaleString()} more shards`}>
          {GACHA_LABEL[r].split(' ')[0]} {PICK_COST[r].toLocaleString()}{shards >= PICK_COST[r] ? " ✓" : ""}
        </span>
      {/each}
    </div>
  {/if}
</div>
